import STORE from '@/app/store/store';
/**
 *
 */
export class Component {
  public $el: JQuery;
  public data = {};

  /**
   * Merge data vào local data
   * @param data data
   */
  mergeData(data: object): void {
    // this.data = {...this.data, ...data};
    this.data = { ...this.data, ...data };
    // // loop over values
    // for (const key in data) {
    //     // eslint-disable-next-line no-prototype-builtins
    //     if (data.hasOwnProperty(key)) {
    //         Object(this.data)[key] = Object(data)[key];
    //     }
    // }
    return;
  }

  /**
   * Lấy toàn bộ computed từ store và set vào local data, ngoài ra sẽ bắt đầu lắng nghe sự kiện từ store
   */
  mergeComputed(): void {
    const computed = this.computed();
    // {
    //     "snippets": "__snippets"
    // }
    if (computed) {
      // loop over values
      for (const keyData in computed) {
        // keyData = snippets
        // eslint-disable-next-line no-prototype-builtins
        if (computed.hasOwnProperty(keyData)) {
          const keyStore = Object(computed)[keyData]; // __snippets
          Object(this.data)[keyData] = STORE.getValue(keyStore); // [{}]
          this.listenStoreChange(keyData, keyStore);
        }
      }
    }
    return;
  }

  /**
   * Lắng nghe store thay đổi
   * @param keyData key trong local data
   * @param keyStore key trong store
   */
  listenStoreChange(keyData: string, keyStore: string): void {
    const watch = this.watch();
    if (watch) {
      // eslint-disable-next-line no-prototype-builtins
      if (watch.hasOwnProperty(keyData)) {
        STORE.onChange(keyStore, (newVal) => {
          let oldVal;
          if (Object(this.data)[keyData] instanceof Object) {
            oldVal = Object.assign({}, Object(this.data)[keyData]);
          } else {
            oldVal = Object(this.data)[keyData];
          }

          // this.data.snippets = newVal
          Object(this.data)[keyData] = newVal;
          // this.onChangeSnippet(newVal, oldVal)
          Object(watch)[keyData].call(this, newVal, oldVal);
        });
      }
    }
  }

  /**
   * Hàm lấy dữ liệu từ store
   * @returns định nghĩa dữ liệu
   */
  computed(): object {
    return {};
  }

  /**
   * Hàm lắng nghe giá trị trong store thay đổi
   * @returns định nghĩa dữ liệu
   */
  watch(): object {
    return {};
  }

  /**
   * listen
   * Hàm lắng nghe các sự kiện từ mọi nơi truyền tới thông qua store
   * ví dụ: Dragable gọi open setting và library gọi open setting
   */
  listen(): void {
    return;
  }

  /**
   * Apply events to dom
   * @param events events được định nghĩa
   * @returns undefine
   */
  applyEvents(events: object): void {
    type Event = {
      target: string;
      event: string;
      namespace: string;
      func(e: JQueryEventObject): void;
    };
    const listenEvents = [] as Array<Event>;
    // loop over values
    for (const key in events) {
      // eslint-disable-next-line no-prototype-builtins
      if (events.hasOwnProperty(key)) {
        // eslint-disable-next-line @typescript-eslint/ban-types
        const targetEvents = Object(events)[key] as object;
        for (const nameEvent in targetEvents) {
          // eslint-disable-next-line no-prototype-builtins
          if (targetEvents.hasOwnProperty(nameEvent)) {
            const event = {} as Event;
            event.target = key;
            event.event = nameEvent.split('.')[0];
            event.namespace = nameEvent.split('.')[1];
            event.func = Object(targetEvents)[nameEvent];
            listenEvents.push(event);
          }
        }
      }
    }

    if (listenEvents?.length) {
      for (let i = 0; i < listenEvents.length; i++) {
        const listenEvent = listenEvents[i];
        let $target;
        if (listenEvent.target == '$el') {
          $target = this.$el;
        } else {
          $target = this.$el.find(listenEvent.target);
        }
        let eventName = listenEvent.event;
        if (listenEvent.namespace) {
          eventName = `${eventName}.${listenEvent.namespace}`;
        }
        $target.off(eventName).on(eventName, (e, ...args) => {
          if (!args || args[1] != false) {
            (listenEvent.func as Function).call(this, e, ...args);
          } else {
            (listenEvent.func as Function).call(this, ...args);
          }
        });
      }
    }
    return;
  }

  /**
   * emit event to parent
   * @param key name
   * @param value data
   * @param isEvent ..
   */
  emit(key: string, value?: any, isEvent = false): void {
    if (!value) {
      value = undefined;
    }
    this.$el.trigger(key, [value, isEvent]);
    return;
  }
}
